
import { defineComponent, reactive, onBeforeMount } from 'vue';
import { Card } from 'ant-design-vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import { useTelaBase } from '@/core/composables/TelaBase';

export default defineComponent({
  name: 'PainelRelatorioVendasBI',

  components: {
    TituloPadrao,
    Card,
  },

  setup() {
    const { telaBase } = useTelaBase();

    const state = reactive({
      tituloRecurso: 'Painel de BI de Vendas',
      biUrl: '', // URL do BI será carregada aqui
    });

    onBeforeMount(async () => {
      // Aqui você pode buscar a URL do BI de um serviço de configuração ou tê-la estaticamente
      // Por exemplo:
      // state.biUrl = await new ServicoConfiguracao().obterUrlBIVendas();
      // Por enquanto, usaremos uma URL de placeholder.
      // Substitua pela URL real do seu BI.
      state.biUrl = 'https://app.powerbi.com/view?r=eyJrIjoiZDI4NGE1YzQtNmU5Zi00N2Q2LWE0MWItZTRlYzNiZDIwN2M0IiwidCI6Ijk5ZjAwMTMzLTY2MmQtNGE3YS1iNjZlLThkMDhmNmEwNzYzMSJ9';
    });

    return {
      state,
      telaBase,
    };
  },
});
